<template>
  <div class="category-content">
    <div class="category-filter" v-for="(category, index) in categories" :key="index">
      <div class="parent-category category" v-if="index === 0">
        <router-link
          :to="categoryLink(category)"
        >
          {{ category.name }}
        </router-link>
      </div>

      <div class="child-category category" v-if="category.productsTotal > 0 && index !== 0">
        <router-link
          :to="categoryLink(category)"
        >
          {{ category.name }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from 'src/compatibility/components/blocks/Category/Sidebar'

export default {
  name: 'CategoryFilter',
  data () {
    return {
      parentId: '',
      categories: []
    }
  },
  props: {
    filters: {
      default: '',
      required: false
    }
  },
  mixins: [Sidebar]
}
</script>

<style lang="scss" scoped>
.category-filter {
  .category {
    margin-bottom: 9px;
    font-size: 16px;
      color: #000;
       .parent-category a{
          color:#f9a000;
           font-weight: 800;
      }
  }
  .category-link {
    color: #f9a000;
    font-weight: 700;
  }
    .category-filter{
        display: inline-block;
    }
    .child-category{
        padding-left: 8px;
    }
}
@media (max-width: 770px) {
    .mobile-category-filter .category-filter{
        text-align: center;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-pack: center;
        justify-content: center;
        -ms-flex-align: center;
        align-items: center;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    }
    .mobile-category-filter {
        display: flex!important;
        overflow: auto;
        padding-left: 0;
    }
    .parent-category{
        display: none;
        line-height: 1;
        font-size: 20px;
        padding-bottom: 6px;
    }
    .child-category:hover {
        background-color: #f9a000;
        a{
            color: #333!important;
        }
    }
    .child-category {
        cursor: pointer;
        background-color: #f7f7f7;
        min-width: 60px;
        max-width: 185px;
        border-radius: 4px;
        margin-right: 4px;
        padding: 10px;
        line-height: 16px;
        display: inline-block;
        width: 100%;
        }
        a{
            overflow-x: hidden;
            white-space: nowrap;
            width: 100%;
            color: #f9a000!important;
            font-weight: 800;
            text-overflow: ellipsis;
            display: inherit;

        }
    }

</style>
